import React from "react";
import BookIcon from "../assets/images/book-icon.svg"
import CollapseIcon from "../assets/icons/collapse-icon.svg"
import {FaqItems} from "../constants/const";
import {Collapse} from "antd";


function Faq () {
    return  (
        <div className="faq-page">
            <div className="faq-page_card">
                <div className="faq-page_card__info">
                    Часто задаваемые вопросы
                </div>
                <img src={BookIcon} alt="icon" />
            </div>

            {FaqItems.map((item, index) => {
                return (
                    <Collapse
                        items={[
                            {
                                key: index,
                                label:
                                    <div className="collapse-item">
                                        <div className="faq-collapse-item-text">{item.title}</div>
                                    </div>,
                                children: <span className="faq-collapse-item-content">{item.content}</span>
                            }]}
                        rootClassName="faq-collapse"
                        key={index}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={() => <img src={CollapseIcon} alt="icon"/>}
                    />
                )
            })
            }
        </div>
    )
}

export default Faq